<div class="body">
  <div class="sticky">
    <app-auth-side-header></app-auth-side-header>
  </div>
  <div class="back-img">
    <div nxLayout="grid" class="back-btn-container container">
      <nx-link nxStyle="block">
        <a routerLink="/login" class="back-btn back-button-font">
          <nx-icon name="arrow-left"></nx-icon>
          {{ "SECRET_ANSWER.BACK" | translate }}
        </a>
      </nx-link>
      <div nxRow class="std-pd-top-2m container">
        <div nxCol="12" class="std-ta-center title-gap">
          <span class="page-title module-title-font">
            {{ "SECRET_ANSWER.TITLE" | translate }}</span
          >
        </div>
        <div nxCol="12,12,12,4" class="question-container std-pd-2m">
          <div>
            <span class="question-label form-label-font">{{
              "SECRET_ANSWER.FORM.SECRET_QUESTION" | translate
            }}</span>
          </div>
          <div>
            <span class="question-desc form-text-font">
              {{ secretQuestionDescp$ | async }}
            </span>
          </div>

          <div>
            <form [formGroup]="secretAnswerForm" (ngSubmit)="onSubmit()">
              <nx-formfield
                [label]="'SECRET_ANSWER.FORM.SECRET_ANSWER' | translate"
                class="secret-answer-label"
              >
                <input
                  #secretAnswer
                  formControlName="secretAnswer"
                  nxInput
                  type="password"
                />
                <nx-password-toggle
                  [control]="secretAnswer"
                  #NxPwTouchToggle
                  [appPasswordTouchToggle]="NxPwTouchToggle"
                  [ariaLabel]="'LOGIN.FORM.SHOW_PASSWORD' | translate"
                  nxFormfieldSuffix
                >
                </nx-password-toggle>
              </nx-formfield>

              <div class="std-pd-bottom-m" *ngIf="secretQuestionError$ | async">
                <nx-error nxFormfieldError class="secQuestErrContainer">
                  <strong class="error-title">
                    {{ secretQuestionError$ | async }}</strong
                  >
                  <br />
                  <a class="fw-regular secQuesErrCont">
                    {{ "SECRET_ANSWER.FORM.ERROR_HELP" | translate }}
                  </a>
                </nx-error>
              </div>
              <div class="std-pd-top-xs">
                <button
                  nxButton
                  type="submit"
                  class="site-header__button button-font std-mg-bottom-m"
                  nxButton="block primary"
                >
                  {{ "SECRET_ANSWER.FORM.SUBMIT" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
